<template>
  <div v-if="selectedItem.slug || mode.edit">
    <div v-if="selectedItem.slug" class="upload-container">
      <ic-firebase-upload
        ref="upload"
        class="upload-btn"
        path="images"
        max-files="1"
        :getFileName="getFileName"
        :storage="storage"
        @uploaded="onUploaded"
        @upload="onUpload"
        @delete="onDelete"
      ></ic-firebase-upload>
      <img :src="previewImage" alt>
    </div>

    <hero-preview :item="selectedItem" :previewImage="previewImage"/>
  </div>
</template>

<script>
import IcFirebaseUploader from "ic-firebase-uploader";
import "ic-firebase-uploader/dist/ic-firebase-uploader.min.css";
import heroPreview from "./widgets/heroPreview";
import { functions } from "firebase";
export default {
  props: ["selectedItem","previewImage","storage", "mode"],
  components: {
    heroPreview,
    "ic-firebase-upload": IcFirebaseUploader,
  },
  data: function() {
    return {
      item: {}
    };
  },
  methods: {
    onUpload: function(e) {
      console.log("upload", e);
      e.doUpload();
      this.searchResults = 0;
      if (e.file) {
        console.log("if upload");
        const reader = new FileReader();
        reader.readAsDataURL(e.file);
        reader.onloadend = () => {
          console.log("reader callback");
          this.$emit('input', reader.result)
        };
      }
    },
    onDelete: function(e) {
      console.log("delete", e);
      this.$refs.upload.$refs.loader.value = "";
      this.$emit('input', this.selectedItem.image);
      e.doDelete();
      this.uploaderKey += 1;
    },
    onUploaded: function(e) {
      console.log("uploaded", e);
      e.getDownloadURL().then(url => {
        this.selectedItem.overrideImage = url;
      });
    },
    getFileName: function(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// ModalSingleArticle.vue?56fa4b22